import { Add, Button, FormCard, Modal, Select } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { goalsConstants } from 'locale/goals'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import GoalsList from 'screens/Residents/screens/ResidentsGoalsScreen/components/GoalsList/GoalsList'
import useGoalsIDs from 'screens/Residents/screens/ResidentsGoalsScreen/components/useGoals/useGoalsIDs'
import styled from 'styled-components'

type CarePlanGoalsListProps = {
  disabled: boolean
  onChange?: (value: string[]) => void
  value: string[]
}

const CarePlanGoalsListInput: FC<CarePlanGoalsListProps> = ({
  disabled = true,
  value,
  onChange,
}) => {
  const { t } = useTranslation(NAMESPACE.GOALS)

  const { id: residentID } = useParams()
  const { filteredGoals, goals } = useGoalsIDs({
    residentID,
    goalsIDs: value,
  })

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [selectedItems, setSelectedItems] = useState(value)

  const addHandler = () => {
    setIsModalVisible(true)
  }
  const confirmHandler = () => {
    onChange?.(selectedItems)

    setIsModalVisible(false)
  }

  const onSelectChange = (
    options: { label: React.ReactNode; value: string }[]
  ) => {
    const newSelectedValues = options.map((option) => option.value)

    setSelectedItems(newSelectedValues)
  }
  const unlinkHandler = (id: string) => {
    const newValue = value.filter((element) => element !== id)

    onChange?.(newValue)
  }

  const options =
    goals?.map((goal) => ({
      label: goal.title,
      value: goal.id,
    })) || []

  const hasGoals = !!filteredGoals?.length

  return (
    <Wrapper>
      <Modal
        noPadding
        localisation={{
          title: t(goalsConstants.SELECT_FROM_AVAILABLE_GOALS),
          confirmText: t(goalsConstants.CONFIRM),
          cancelText: t(goalsConstants.CANCEL),
        }}
        onCancel={() => setIsModalVisible(false)}
        onConfirm={() => confirmHandler()}
        isModalVisible={isModalVisible}
      >
        <Select<string[], { label?: React.ReactNode; value: string }>
          defaultValue={value}
          style={{ width: '100%' }}
          options={options}
          mode="multiple"
          onChange={(value, options) => onSelectChange(options as [])}
          placeholder={t(goalsConstants.GOALS)}
        />
      </Modal>
      <FormCard
        title={t('components.logEditForm.linkedGoals', {
          ns: NAMESPACE.RESOURCES,
        })}
        rightChildren={
          !disabled && (
            <Button
              type="button"
              variant="text"
              icon={<Add />}
              onClick={() => addHandler()}
              disabled={disabled}
            >
              {t(goalsConstants.LINK_A_GOAL)}
            </Button>
          )
        }
      >
        {hasGoals ? (
          <GoalsListStyled
            residentID={residentID}
            disabled={disabled}
            items={filteredGoals || []}
            onUnlink={unlinkHandler}
            hasBorder
          />
        ) : null}
      </FormCard>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: 30px;
`

const GoalsListStyled = styled(GoalsList)`
  > h4 {
    opacity: 0.7;
    color: rgb(51, 51, 51);
    font-weight: 700;
  }
`

export default CarePlanGoalsListInput
